import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const MobileWrapper = styled.div`
  display: none;

  @media (max-width: 800px) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`

export const DesktopWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  & > img {
    width: 50%;
    height: 100%;
    background-position: cover;
  }

  @media (max-width: 800px) {
    display: none;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 55%;
  flex-grow: 1;
  padding: 0 60px;
  background-color: #ffffff;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const Banner = styled.div`
  width: 45%;

  @media (max-width: 800px) {
    width: 100%;
    height: 250px;
  }
`

export const MailWrapper = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 800px) {
    width: 100%;
    text-align: center;
  }
`

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  background-position: cover;
`

export const Title = styled.span`
  font-size: 45px;
  margin-top: 10px;
  font-weight: 400;

  & span:nth-of-type(1) {
    color: #343434;
    margin-right: 10px;
  }

  & span:nth-of-type(2) {
    color: #ec0000;
  }
`

export const SecondFormTitle = styled.span`
  font-size: 34px;
  font-weight: 400;
  margin-bottom: 24px;

  & span:nth-of-type(1) {
    color: #343434;
    margin-right: 10px;
  }

  & span:nth-of-type(2) {
    color: #ec0000;
  }

  @media (max-width: 800px) {
    text-align: center;
    display: flex;
    flex-direction: column;
    font-size: 30px;
    align-items: center;
  }
`

export const ThirdFormTitle = styled.span`
  font-size: 24px;
  width: 80%;
  margin: 30px 0 24px;
  text-align: center;
  font-weight: bold;

  & span:nth-of-type(1) {
    color: #343434;
    margin-right: 5px;
  }

  & span:nth-of-type(2) {
    color: #ec0000;
  }

  @media (max-width: 800px) {
    width: 95%;
  }
`

export const Text = styled.span`
  font-size: 14px;
  width: 50%;
  margin-bottom: 10px;
  font-weight: 300;
`

export const MailButton = styled.button`
  display: flex;
  text-align: center;
  align-items: center;
  padding: 10px 20px;
  border: 1px solid #cbcbcb;
  background-color: #ffffff;
  cursor: pointer;
  color: #454545;
  font-size: 20px;
  margin-bottom: 10px;
  border-radius: 6px;

  @media (max-width: 800px) {
    font-size: 18px;
  }
`

export const MailIcon = styled.img`
  width: 35px;
  height: 20px;
  margin-right: 10px;
`

export const TitleContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Link = styled.span`
  margin-top: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  color: #337ab7;
  font-size: 14px;
`

export const Button = styled.button`
  width: auto;
  padding: 10px 40px;
  cursor: pointer;
  border: none;
  font-size: 16px;
  font-weight: bold;
  border-radius: 6px;
  background-color: #ec0000;
  align-self: center;
  color: #ffffff;
  text-transform: uppercase;
  margin: 22px 0;

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`

export const Description = styled.div`
  font-size: 38px;
  margin-bottom: 10px;
  color: #646464;
`

export const SecondDescription = styled.div`
  margin: 20px 0;
  color: #646464;
  font-size: 24px;

  @media (max-width: 800px) {
    text-align: center;
    font-size: 20px;
  }
`

export const Anchor = styled.a`
  color: #454545;
  font-size: inherit;
  text-decoration: underline;
`

export const Label = styled.label`
  margin-bottom: 10px;
  padding-top: 10px;
  color: #4f4f4f;
  font-size: 16px;
`

export const ThirdLabel = styled.label`
  margin-bottom: 20px;
  padding-top: 10px;
  color: #454545;
  font-size: 20px;
  text-transform: uppercase;
`

export const GridLabel = styled.label`
  width: 50%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  color: #4f4f4f;
  font-size: 16px;
  white-space: nowrap;
`

export const Errors = styled.span`
  color: #b22222;
  font-size: 12px;
  margin-top: 4px;
`

export const Info = styled.span`
  color: #646464;
  font-size: 12px;
`

export const TextArea = styled.textarea`
  margin-bottom: 10px;
  width: 100%;
  min-height: 90px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  resize: vertical;
  padding: 14px;
  text-align: left;
`

export const Input = styled.input`
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  padding: 12px 6px;
  border-radius: 5px;
`

export const InputDate = styled.input`
  width: auto;
  height: 40px;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  padding: 10px 20px;
  border-radius: 5px;
`

export const Attention = styled.span`
  color: #b22222;
  font-size: 15px;
`

export const Select = styled.select`
  width: auto;
  height: 40px;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 10px 30px;
  color: #4f4f4f;
`

export const Upload = styled.input`
  width: 300px;
  height: 30px;
  border-radius: 5px;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
`

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-bottom: 20px;
`

export const CheckboxWrapper = styled.div`
  width: 50%;
  display: flex;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  padding-top: 20px;
`

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  min-width: 18px;
  margin: 0 10px 0 0;
  accent-color: #ec0000;
  cursor: pointer;
`

export const FormContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px 40px;

  @media (max-width: 800px) {
    padding: 20px 20px 60px;
  }
`

export const InputWrapper = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const InputDateWrapper = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
  row-gap: 5px;

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const GridItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`

export const SocialWrapper = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 800px) {
    width: 100%;
    flex-direction: column;
  }
`

export const NextButton = styled.button`
  background-color: #e90000;
  cursor: pointer;
  width: auto;
  border: none;
  color: white;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 6px;
  margin-top: 30px;
  padding: 10px 60px;
`

export const PhotoGrid = styled.div`
  width: min(900px, 95%);
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 28px;
  align-items: start;
  margin-bottom: 26px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`

export const PhotoBlock = styled.div<{ $wide?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ $wide }) => ($wide ? 'stretch' : 'center')};
  padding: 18px;
  border: 1px solid #e4e4e4;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.05);
`

export const PhotoTitle = styled.div`
  width: 100%;
  color: #343434;
  font-size: 17px;
  font-weight: 600;
  text-align: left;
`

export const PhotoDescription = styled.div`
  width: 100%;
  color: #777777;
  font-size: 12px;
  line-height: 1.4;
  margin: 4px 0 14px;
  text-align: left;
`

export const ProfileUploadLabel = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`

export const ImageCircle = styled.div`
  width: 118px;
  height: 118px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f1f1f1;
  border: 2px dashed #c7c7c7;
`

export const ProfilePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const CoverDiv = styled.div<{ $hasImage?: boolean }>`
  width: 100%;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  border-radius: 10px;
  background-color: #f1f1f1;
  border: ${({ $hasImage }) =>
    $hasImage ? '1px solid #dedede' : '2px dashed #c7c7c7'};

  @media (max-width: 800px) {
    height: 150px;
  }
`

export const CoverPreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const LabelUpload = styled.label`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`

export const ProfileUploadLogo = styled.img`
  width: 54px;
  height: 54px;
  opacity: 0.72;
`

export const UploadHint = styled.span`
  margin-top: 9px;
  color: #c62a31;
  font-size: 13px;
  font-weight: 600;
`

export const RemovePhotoButton = styled.button`
  align-self: center;
  margin-top: 8px;
  padding: 0;
  border: none;
  background: transparent;
  color: #777777;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
`

export const AgreeWrapper = styled.div`
  width: min(680px, 90%);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 14px;
  border-radius: 8px;
  background: #fafafa;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const PolicyText = styled.div`
  color: #4f4f4f;
  font-size: 14px;
  line-height: 1.45;
`

export const PolicyError = styled.span`
  margin-top: 6px;
  color: #b22222;
  font-size: 12px;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  right: 0;
  border: none;
  margin: 5px 5px 0 0;
  background-color: #f5f5f5;
`

export const CloseButtonIcon = styled.img`
  width: 30px;
  height: 30px;
`

export const LoginButton = styled.button`
  border: none;
  background: unset;
  cursor: pointer;
  font-size: 16px;
  color: #616161;
`
